exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.attachment-error{width:320px;position:relative;margin:0 auto;background-color:#fff}.attachment-error .display-container .warning-icon{display:flex;justify-content:center;margin-top:160px}.attachment-error .display-container .retry-text,.attachment-error .display-container .warning-text{text-align:justify;text-align-last:center;font-family:Open Sans,sans-serif;font-size:24px;font-weight:700;color:#184e78}.attachment-error .display-container .retry-text{text-decoration:underline;cursor:pointer}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/containers/PORContainer/PORProjectDocuments/AttachmentsTable/AttachmentError/AttachmentError.scss
// module id = 1772
// module chunks = 0